// Module
var code = "<template> <input ref=\"autocompleteField\" type=\"text\" autocomplete=\"off\" class=\"form-control\" placeholder.bind=\"placeholder\" value.bind=\"street & validate\" disabled.bind=\"disabled\"/> </template> ";
// Exports
export default code;